<template>
 <div class="myworks__list-item">
  <img :src="require('@/images/' + projectItem.img)" alt="photo" class="myworks__list-item-img">
  <div class="myworks__list-item-info">
   <h3><strong>Title:</strong> {{ projectItem.title }}</h3>
   <p><strong>Stack:</strong> <strong>{{ projectItem.stack }}</strong></p>
   <p><strong>Description:</strong> {{ projectItem.description }}</p>

   <div class="myworks__list-item-info-links">
    <a :href=projectItem.git_link>Github Link</a>
    <a :href=projectItem.live_link>Live Link</a>
   </div>
  </div>
 </div>
</template>

<script>
 export default {
  props: {
   projectItem: {
    type: Object,
    required: true,
   }
  }
 }
</script>

<style>
.myworks__list-item {
 display: grid;
 grid-template-columns: 1fr 2fr;
 gap: 20px;
 padding-bottom: 15px;
 border-bottom: 1px solid grey;
 margin-bottom: 15px;
}
.myworks__list-item-img {
 width: 100%;
 border: 1px solid grey;
 border-radius: 10px;
}
.myworks__list-item-info {
 color: #f3f3f3;
}
.myworks__list-item-info h3 {
 color: #cea25f;
}
.myworks__list-item-info strong {
 color: #f3f3f3;
}
.myworks__list-item-info p {
 margin-top: 10px;
}
.myworks__list-item-info-links {
 display: flex;
 align-items: center;
 gap: 15px;
 margin-top: 15px;
}
.myworks__list-item-info-links a {
 color: #f3f3f3;
 background-color: #cea25f;
 padding: 10px 15px;
 border-radius: 15px;
 text-decoration: none;
 outline: none;
}
.myworks__list-item-info-links a:hover {
 background-color: #ae8445;
}
@media only screen and (max-width: 750px) {
 .myworks__list-item {
  grid-template-columns: 1fr;
 }
 .myworks__list-item-info-links{
  justify-content: center;
 }
}
@media only screen and (max-width: 350px) {
 .myworks__header-h1 {
  font-size: 1.2rem;
 }
 .myworks__header-p {
  padding: 0 10px;
 }
 .myworks__list-item-info-links a {
  padding: 5px 10px;
  border-radius: 10px;
 }
}
</style>